import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { serviceListDemoData } from '../../../../data/ServiceDemoData';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { ApiGetServicesList } from './ServicesManageOperation';

const ServicesManageContext = createContext();

export const useServiceManage = () => useContext(ServicesManageContext);

function ServicesManageProvider({ children }) {
    const [params, setParams] = useState({});
    // --Data reload
    const [reloadKey, setReloadKey] = useState(0);
    // --Store initial data
    const [serviceManageData, setServiceManageData] = useState({
        servicesList: serviceListDemoData,
        pagination: {}
    });
    const [showActivityModal, setShowActivityModal] = useState({ show: false, data: {} });
    const { setMessage } = useTemplate();

    // -- Load all customer initially
    useEffect(() => {
        setServiceManageData({ servicesList: serviceListDemoData, pagination: {} });
        if (Object.keys(params).length > 0) {
            ApiGetServicesList(params)
                .then(({ data }) => {
                    setServiceManageData(data);
                })
                .catch((err) => {
                    setServiceManageData({ servicesList: [], pagination: {} });
                    setMessage({ type: 'error', text: err.toString(0) });
                });
        }
    }, [setMessage, reloadKey, params]);

    const value = useMemo(() => {
        // -- Reload Button
        const handleReload = () => {
            setReloadKey((d) => d + 1);
        };

        return {
            // Filter Data
            params,
            setParams,
            // Subscriptions Data
            serviceManageData,
            setServiceManageData,
            // -- Reload
            reloadKey,
            setReloadKey,
            handleReload,
            showActivityModal,
            setShowActivityModal
        };
    }, [params, reloadKey, serviceManageData, showActivityModal]);

    return (
        <ServicesManageContext.Provider value={value}>{children}</ServicesManageContext.Provider>
    );
}

export default ServicesManageProvider;
